// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-picture-box_ProjectPictureBox__ExQBQ {
    width: 100%;
    margin: 3px;
    height: 62px;
    margin-top: 0;
    max-width: 110px;
    overflow: hidden;
    text-align: right;
    border-radius: 10px;
    vertical-align: top;
    display: inline-block;
    float: none !important;
    border: 1px solid #D6E5B8;
}

@media (min-width: 1200px) {
    .project-picture-box_ProjectPictureBox__ExQBQ {
        margin: 10px;
        margin-top: 0;
        height: 200px;
        max-width: 356px;
        border-radius: 30px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/project-picture-box/project-picture-box.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;AACJ","sourcesContent":[".ProjectPictureBox {\r\n    width: 100%;\r\n    margin: 3px;\r\n    height: 62px;\r\n    margin-top: 0;\r\n    max-width: 110px;\r\n    overflow: hidden;\r\n    text-align: right;\r\n    border-radius: 10px;\r\n    vertical-align: top;\r\n    display: inline-block;\r\n    float: none !important;\r\n    border: 1px solid #D6E5B8;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .ProjectPictureBox {\r\n        margin: 10px;\r\n        margin-top: 0;\r\n        height: 200px;\r\n        max-width: 356px;\r\n        border-radius: 30px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ProjectPictureBox": `project-picture-box_ProjectPictureBox__ExQBQ`
};
export default ___CSS_LOADER_EXPORT___;
